require('src/pc/product_search');
require('jquery-ui/ui/effect')
require('jquery-ui/ui/effects/effect-highlight')
require("packs/smart_phone/jquery.flexslider-min")
